<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Privacy & Policy</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Create New Privacy & Policy</b>

      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Title (Bahasa)" label-for="input-1">
            <input
              v-validate="'required'"
              v-model="title_id"
              name="title_id"
              id="input-1"
              class="form-control"
              placeholder="Title In Bahasa Indonesia"
            />
            <b-form-invalid-feedback id="input-title_id-feedback">{{ veeErrors.first('title_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Title (English)" label-for="input-1">
            <input
              v-validate="'required'"
              v-model="title_en"
              name="title_en"
              class="form-control"
              placeholder="Title In English"
            />
            <b-form-invalid-feedback id="input-title_en-feedback">{{ veeErrors.first('title_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Content (Bahasa)" label-for="input-1">
            <textarea
              v-model="content_id"
              v-validate="'required'"
              class="form-control"
              name="content_id"
              placeholder="Enter a Content Bahasa"
            />
            <b-form-invalid-feedback
              id="input-content_id-feedback"
            >{{ veeErrors.first('content_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Content (English)" label-for="input-1">
            <textarea
              v-model="content_en"
              v-validate="'required'"
              class="form-control"
              name="content_en"
              placeholder="Enter a Content English"
            />
            <b-form-invalid-feedback
              id="input-content_en-feedback"
            >{{ veeErrors.first('content_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="fieldset-1" label="Point (Bahasa)" label-for="input-1">
            <ckeditor
              @input="isHiddenBahasa = true"
              :editor="editor"
              tag-name="textarea"
              placeholder="Point in Bahasa"
              v-model="point_id"
              class="form-control"
              :config="editorConfig"
            ></ckeditor>
            <div
              v-show="isHiddenBahasa"
              class="text-danger"
              id="input-point_id-feedback"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >
              <p v-if="point_id.length === 0">The point bahasa field is required</p>
            </div>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="fieldset-1" label="Point (English)" label-for="input-1">
            <ckeditor
              @input="isHiddenEnglish = true"
              :editor="editor"
              tag-name="textarea"
              placeholder="Point in English"
              v-model="point_en"
              class="form-control"
              :config="editorConfig"
            ></ckeditor>
            <div
              v-show="isHiddenEnglish"
              class="text-danger"
              id="input-point_en-feedback"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >
              <p v-if="point_en.length === 0">The point english field is required</p>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row class="text-right">
        <b-col>
          <b-button
            variant="primary"
            :disabled="veeErrors.any() || !isCompleted || loading"
            @click="post()"
            class="mr-3"
            size="lg"
          >
            Save
            <b-spinner v-if="loading" small label="Loading..."></b-spinner>
          </b-button>
          <router-link :to="{name: 'Privacypolicy'}">
            <b-button variant="outline-secondary" size="lg">Cancel</b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          'fontSize',
          '|',
          'bold',
          'italic',
          'underline',
          'fontColor',
          '|',
          'alignment',
          'bulletedList',
          'numberedList',
          'outdent',
          'indent',
          'link',
          '|',
          'strikethrough',
        ],
      },
      selected: '',
      loading: false,
      page_number: '',
      title_id: '',
      title_en: '',
      point_id: '',
      point_en: '',
      content_id: '',
      content_en: '',
      isHiddenEnglish: false,
      isHiddenBahasa: false,
      options: [
        { text: 'Paxel.co Website', value: 'web' },
        { text: 'User App', value: 'user' },
        { text: 'Hero App', value: 'hero' },
      ],
    };
  },
  methods: {
    post() {
      this.loading = true;
      const formData = new FormData();
      formData.append('title_id', this.title_id);
      formData.append('title_en', this.title_en);
      formData.append('content_id', this.content_id);
      formData.append('content_en', this.content_en);
      formData.append('point_id', this.point_id);
      formData.append('point_en', this.point_en);
      this.$store
        .dispatch('PrivacypolicyModule/postPrivacyPolicy', formData)
        .then((response) => {
          this.loading = false;
          this.$router.push({ name: 'Privacypolicy' });
          this.$swal({
            type: 'success',
            title: 'Your work has been saved',
            showConfirmButton: false,
            timer: 1500,
          });
          console.log(response);
        })
        .catch((error) => {
          this.loading = false;
          this.$swal({
            type: 'error',
            title: 'Oops...',
            text: error.response.data,
            showConfirmButton: false,
            timer: 1500,
          });
          this.serverError = error.response.data;
          console.log(error);
        });
    },
  },
  computed: {
    isCompleted() {
      return (
        this.title_id
        && this.title_en
        && this.content_id
        && this.content_en
        && this.point_id
        && this.point_en
      );
    },
  },
};
</script>

<style>
</style>
